<template>
  <div class="pt-2">
    <div class="container">
      <div class="d-flex flex-column align-items-center">
        <div class="title">Modules</div>
        <div class="subtitle">Manage all your module settings with ease</div>
        <div class="permissions-box d-flex flex-column">
          <div class="permissions-section d-flex flex-column">
            <div class="section-title">HR</div>

            <div class="permissions-list d-flex-flex-column">
              <div class="permission" v-for="permission of hrPermissions">
                <div class="d-flex justify-content-between align-items-center each-permission-box">
                  <div class="each-permission d-flex flex-column">
                    <div class="permission-title">{{ permission.title }}</div>
                    <div class="permission-subtitle">
                      {{ permission.subtitle }}
                    </div>
                  </div>
                  <div>
                    <div class="custom-control custom-switch">
                      <input
                          type="checkbox"
                          class="custom-control-input"
                          :checked="permission.checked"
                          @change="togglePermissions('hrPermissions', permission.slug, $event)"
                          :id="permission.slug"
                          :disabled="permission.required"
                      />
                      <label
                          class="custom-control-label cursor-default"
                          :for="permission.slug"
                      >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="permissions-section d-flex flex-column">
            <div class="section-title">Recruitment</div>
            <div class="permissions-list d-flex-flex-column">
              <div class="permission" v-for="permission of recruitmentPermissions">
                <div class="d-flex justify-content-between align-items-center each-permission-box">
                  <div class="each-permission d-flex flex-column">
                    <div class="permission-title">{{ permission.title }}</div>
                    <div class="permission-subtitle">
                      {{ permission.subtitle }}
                    </div>
                  </div>
                  <div>
                    <div class="custom-control custom-switch">
                      <input
                          type="checkbox"
                          class="custom-control-input"
                          :checked="permission.checked"
                          @change="togglePermissions('recruitmentPermissions', permission.slug, $event)"
                          :id="permission.slug"
                          :disabled="permission.required"
                      />
                      <label
                          class="custom-control-label cursor-default"
                          :for="permission.slug"
                      >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="permissions-section d-flex flex-column">
            <div class="section-title">Work</div>
            <div class="permissions-list d-flex-flex-column">
              <div class="permission" v-for="permission of workPermissions">
                <div class="d-flex justify-content-between align-items-center each-permission-box">
                  <div class="each-permission d-flex flex-column">
                    <div class="permission-title">{{ permission.title }}</div>
                    <div class="permission-subtitle">
                      {{ permission.subtitle }}
                    </div>
                  </div>
                  <div>
                    <div class="custom-control custom-switch">
                      <input
                          type="checkbox"
                          class="custom-control-input"
                          :checked="permission.checked"
                          @change="togglePermissions('workPermissions', permission.slug, $event)"
                          :id="permission.slug"
                          :disabled="permission.required"
                      />
                      <label
                          class="custom-control-label cursor-default"
                          :for="permission.slug"
                      >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['companyId'],
  data () {
    return {
      hrPermissions: [
        {
          slug: 'general_settings',
          title: 'General Settings',
          subtitle: 'General, offices and holiday settings',
          required: true,
          checked: false,
        },
        {
          slug: 'employee_management',
          title: 'Employee Management',
          subtitle: 'Grant & manage your team member access',
          required: true,
          checked: false,
        },
        {
          slug: 'policy_management',
          title: 'Policy Management',
          subtitle: 'Implementing time-off policies and procedures within organisation',
          required: true,
          checked: false,
        },
        {
          slug: 'leaves_management',
          title: 'Leave Management',
          subtitle: 'Manage your team leave applications easily',
          checked: false,
        },
        {
          slug: 'payroll',
          title: 'Payroll',
          subtitle: 'Automate your payroll and save time',
          checked: false,
        },
        {
          slug: 'claims',
          title: 'Claims',
          subtitle: 'Allows team to easily send your claim for reimbursement',
          checked: false,
        },
        {
          slug: 'onboarding',
          title: 'Onboarding',
          subtitle: 'Integrating a new employee into an organization',
          checked: false,
        },
        {
          slug: 'survey',
          title: 'Survey',
          subtitle: 'Collecting data from employee to gain information and insights',
          checked: false,
        },
      ],
      recruitmentPermissions: [
        {
          slug: 'recruitment',
          title: 'Recruitment',
          subtitle: 'Declutter your job search through an automated recruitment algorithm',
          checked: false,
        },
      ],
      workPermissions: [
        {
          slug: 'remote_readiness',
          title: 'Remote Readiness',
          subtitle: 'Check if your team is ready to work remotely.',
          checked: false,
        },
        {
          slug: 'check_ins',
          title: 'Check In',
          subtitle: 'Communicate better when you know when your team is checked-in and on-break.',
          checked: false,
        },
        {
          slug: 'tasks',
          title: 'Tasks & Time Sheet',
          subtitle: 'Plan, Manage & Track tasks for you and your teammates.',
          checked: false,
        },
        {
          slug: 'freelancer_report',
          title: 'Freelancer Report',
          subtitle: 'View and manage finances for freelancers',
          checked: false,
        },
      ],
    };
  },
  computed: {
    timezone () {
      return this.$store.state.timezone;
    },
  },
  methods: {
    getModulePermissionsUrl () {
      return route('tribesuite.module-permissions');
    },
    async togglePermissions (group, type, event) {
      const checked = event.target.checked;
      const vm = this;

      try {
        const response = await axios.post(route('tribesuite.post-module-permissions'), {
          isEnabled: checked,
          permission: type,
          companyId: this.companyId,
        });

        if (response.data == 'success') {
          for (const permission of vm[group]) {
            if (permission.slug === type) {
              permission.checked = checked;
            }
          }

          // add logic for policy permission to follow leave permission
          if(type === 'leaves_management'){
            const policyResponse = await axios.post(route('tribesuite.post-module-permissions'), {
              isEnabled: checked,
              permission: "policy_management",
              companyId: this.companyId,
            });

            if(policyResponse.data == 'success'){
              vm[group].find(g=>g.slug == 'policy_management').checked = checked;
            }
          }
        }

      } catch (error) {
        console.log(error);
      }
    },
    async getCompanyPermissions () {
      try {
        const response = await axios.get(route('tribesuite.list-module-permissions', { companyId: this.companyId }));
        const data = response?.data?.company_module_permissions

        if (data) {
          // hide payroll exception until licensed
          const exceptions = ['payroll']
          exceptions.forEach(slug => {
            const check = data.find(d => d.permission_name == slug);
            if (!check) {
              this.hrPermissions = this.hrPermissions.filter(a => a.slug != slug)
            }
          });

          for (let i = 0; i < data.length; i++) {
            const permission = data[i];

            for (const hrPermission of this.hrPermissions) {
              if (hrPermission.slug === permission.permission_name) {
                hrPermission.checked = permission.is_enabled === 1;
                break;
              }
            }

            for (const workPermission of this.workPermissions) {
              if (workPermission.slug === permission.permission_name) {
                workPermission.checked = permission.is_enabled === 1;
                break;
              }
            }

            for (const recruitmentPermission of this.recruitmentPermissions) {
              if (recruitmentPermission.slug === permission.permission_name) {
                recruitmentPermission.checked = permission.is_enabled === 1;
                break;
              }
            }
          }
        }

      } catch (error) {
        console.log(error);
      }
    },
  },
  created () {
    this.getCompanyPermissions();
  },
  mounted () {
    console.log(this.companyId);
  },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/core/mixins";

.title {
  color: #303030;
  font-size: 38px;
  font-family: Avenir, sans-serif;
  font-weight: bold;
  margin-top: 10px;
}

.subtitle {
  color: #797979;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
}

.permissions-box {
  margin-top: 40px;
  width: 700px;
}

.permissions-section {
  width: 100%;
  margin-bottom: 16px;
}

.section-title {
  color: #ff375e;
  font-family: Avenir, sans-serif;
  font-weight: bold;
  font-size: 16px;
}

.permission-title {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: bold;
}

.permission-subtitle {
  color: #8997aa;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
}

.permission-divider {
  height: 0.5px;
}

.custom-switch .custom-control-label::before {
  width: 3rem;
  height: 1.5rem;
  border-radius: 1.5rem;
}

.custom-switch .custom-control-label::after {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 2rem;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(1.5rem);
}

.custom-switch {
  margin-right: 15px;
}

.custom-control-label {
  cursor: pointer;
}

.cursor-default {
  cursor: default;
}

.permissions-list .permission {
  margin-bottom: 12px;
  padding-bottom: 8px;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>
